import React from 'react'
import { connect } from 'react-redux'
import { unsetModal } from '../../actions/modal-actions'
import ComponentStateModal from './index'
import { addHarnessProblem } from '../../api/controller-api'
import {
  getDtcCodesFromHighlightedDtcs,
  getHistoryForSelectedModalComponent,
} from '../../selectors'
import { getElementName } from '../../helpers/element'
import { FormattedMessage } from 'react-intl'

const mapStateToProps = (state, ownProps) => {
  return {
    isOpen: state.modalState.isOpen,
    vehicleTestResultId: state.componentState.vehicleTestResultId,
    makeModelId: state.componentState.makeModelId,
    harnessLevel: state.modalState.component?.level,
    harness: state.modalState.component?.harness,
    stationId: state.modalState.component?.assembly_station?.[0] ?? null,
    dtcs: getDtcCodesFromHighlightedDtcs(state),
    historyForComponent:
      state.loggingState.historiesForComponents[
        state.modalState.component?.harness
      ],
    vin: state.componentState.vin,
    selectedComponent: state.modalState.component,
    identifier: state.modalState?.component?.harness,
    faults: state.loggingState.faults.harness,
    title: getElementName(state.modalState.component),
    placeHolder: (
      <FormattedMessage id="tracer.logFailure.typePlaceholderHarness" />
    ),
    componentType: 'harness',
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onClose: () => {
      dispatch(unsetModal())
    },
    _onSubmit: ({
      annotation,
      vehicleTestResultId,
      makeModelId,
      vin,
      reason,
      harnessLevel,
      dtcs,
      harness,
      stationId,
    }) => {
      const res = addHarnessProblem({
        annotation,
        vehicleTestResultId,
        harness,
        makeModelId,
        vin,
        reason,
        harnessLevel,
        dtcs,
        stationId,
      })
      dispatch(unsetModal())
      return res
    },
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...stateProps, // optional
    ...dispatchProps, // optional
    onSubmit: (args) => {
      return dispatchProps._onSubmit({
        ...args,
        vehicleTestResultId: stateProps.vehicleTestResultId,
        makeModelId: stateProps.makeModelId,
        vin: stateProps.vin,
        harnessLevel: stateProps.harnessLevel,
        dtcs: stateProps.dtcs,
        harness: stateProps.harness,
        stationId: stateProps.stationId,
      })
    },
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(ComponentStateModal)
